import { useState, useEffect, useCallback } from 'react';
import { ApiResponse } from '../typings/ApiResponse';
import { ResidentDetails } from '../typings/ResidentTypes';
import { getStepOneDetails } from '../api/resident';

const useResidentDetailsFetch = (slug: string | undefined) => {
  const [residentDetails, setResidentDetails] = useState<ResidentDetails>();

  const fetchData = useCallback(async () => {
    if (slug) {
      try {
        const response: ApiResponse<ResidentDetails> =
          await getStepOneDetails(slug);
        if (response && response.status === 'success') {
          setResidentDetails(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [slug]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    residentDetails,
    refetch: fetchData,
  };
};

export default useResidentDetailsFetch;
